export default __webpack_public_path__ + "static/media/first-edition-background.28bf853c.jpg";